import BadgeCheckIcon from "@/assets/svg/badge-check-black.svg";
import Avatar1 from "@/assets/svg/creator-shield/avatar/1.svg";
import Avatar2 from "@/assets/svg/creator-shield/avatar/2.svg";
import Avatar3 from "@/assets/svg/creator-shield/avatar/3.svg";
import Avatar4 from "@/assets/svg/creator-shield/avatar/4.svg";
import Coin from "@/assets/svg/creator-shield/bg-icons/coin.svg";
import DollarCoin from "@/assets/svg/creator-shield/bg-icons/dollar-coin.svg";
import FilePlay from "@/assets/svg/creator-shield/bg-icons/file-play.svg";
import Film from "@/assets/svg/creator-shield/bg-icons/film.svg";
import Fingerprint from "@/assets/svg/creator-shield/bg-icons/fingerprint.svg";
import FolderSeach from "@/assets/svg/creator-shield/bg-icons/folder-search.svg";
import ShieldCheckOutline from "@/assets/svg/creator-shield/bg-icons/shield-check.svg";
import Video from "@/assets/svg/creator-shield/bg-icons/video.svg";
import BlurBg from "@/assets/svg/creator-shield/hero-section-blur.svg";
import PirateHat from "@/assets/svg/creator-shield/pirate-hat.svg";
import ShieldCheck from "@/assets/svg/creator-shield/shield-check.svg";
import YoutubeIcon from "@/assets/svg/youtube-icon.svg";
import {
  CSPrimaryBtn,
  CSTertiaryBtn,
} from "@/components/design-system/creatorshield/CSButton";
import scrollTo from "@/utils/scrollTo";
import { Link } from "react-router-dom";
import Statistics from "./Statistics";
import { useScrollAnimation } from "@/hooks/useScrollAnimation";

export default function Header() {
  const headlineRef = useScrollAnimation({ threshold: 0.2 });
  
  return (
    <div className="bg-white pt-[120px] pb-16 px-6 md:px-16 relative overflow-hidden space-y-12">
      <div className="4xl:max-w-[100rem] 4xl:mx-auto relative space-y-8">
        <div className="flex justify-center mt-0 lg:mt-5 lg:mb-[-5px]">
          <div className="flex items-center gap-[4px] bg-[#f6f6f6] border border-[#d9d9d9] rounded-full px-3 py-1">
            <img
              src={YoutubeIcon}
              alt="YouTube Icon"
              className="w-[30px] h-[32px]"
            />
            <span className="font-normal text-black leading-normal whitespace-nowrap">
              Official YouTube Certified
            </span>
            <img
              src={BadgeCheckIcon}
              alt="Badge Check Icon"
              className="w-5 h-5"
            />
          </div>
        </div>

        {/* Main Headline */}
        <div ref={headlineRef} className="text-center space-y-8 relative z-10 animate-fade-rise">
          <h1 className="text-3xl md:text-6xl lg:text-7xl xl:text-[110px] font-semibold text-black leading-[1.1] max-w-[1100px] mx-auto">
            <span className="lg:hidden">
              Claim your slice of the{" "}
              <span className="relative lg:inline-block z-10">
                <span className="relative bg-[#FF6B35] text-white px-[8px] py-[8px] rounded-[16px] mx-auto lg:mx-2 transform rotate-[-2.328deg] h-[100px] flex items-center justify-center w-[180px] mt-8 lg:mt-2 mb-6 lg:mb-0">
                  <span className="text-[80px] font-bold leading-normal text-center whitespace-nowrap">
                    $9B
                  </span>
                  {/* Pirate Hat Icon */}
                  <div className="absolute left-[-32px] top-[-35px] lg:top-[-42px] w-[72px] h-[72px] flex items-center justify-center transform rotate-[-6deg] lg:rotate-[335.737deg]">
                    <div className="w-[55px] h-[55px] overflow-hidden">
                      <img
                        src={PirateHat}
                        alt="Pirate Hat"
                        className="w-full h-full"
                      /> 
                    </div>
                  </div>
                </span>
              </span>{" "}
              <span className="text-[#FF6B35]">piracy pie</span>
            </span>
            <span className="hidden lg:inline">
              Claim your slice of the{" "}
              <span className="relative inline-block z-10">
                <span className="relative bg-[#FF6B35] text-white px-[10px] py-[10px] rounded-[20px] mx-2 transform rotate-[-2.328deg] h-[140px] flex items-center justify-center w-[250px] mt-4">
                  <span className="text-[110px] font-bold leading-normal text-center whitespace-nowrap">
                    $9B
                  </span>
                  {/* Pirate Hat Icon */}
                  <div className="absolute left-[-50.94px] top-[-50.51px] w-[100.981px] h-[100.981px] flex items-center justify-center transform rotate-[350.737deg]">
                    <div className="w-[76.351px] h-[76.351px] overflow-hidden">
                      <img
                        src={PirateHat}
                        alt="Pirate Hat"
                        className="w-full h-full"
                      />
                    </div>
                  </div>
                </span>
              </span>{" "}
              <span className="text-[#FF6B35]">piracy pie</span>
            </span>
          </h1>

          {/* Decorative Shield Icon */}
          {/* Customize position for each view:
              MOBILE: right-0 top-14 (xxs default) | xs:right-0 xs:top-14 (390px+) | md:right-20 md:top-14 (768px+)
              LAPTOP: lg:right-[65px] lg:top-[46px] (1024px+)
              WIDE SCREEN: xl:right-[65px] xl:top-14 (1280px+) | 1xl:right-[65px] 1xl:top-14 (1440px+) | 2xl:right-[65px] 2xl:top-14 (1536px+) | 3xl:right-[65px] 3xl:top-14 (1920px+) | 4xl:right-[65px] 4xl:top-10 (2560px+)
          */}
          <div
            className="absolute 
            right-0 top-14
            xxs:right-[5px] xxs:top-[145px] 
            xs:right-[40px] xs:top-[120px] 
            md:right-[114px] md:top-[205px] 
            lg:right-[55px] lg:top-[40px] 
            xl:right-[-25px] xl:top-16 
            1xl:right-[90px] 1xl:top-16
            2xl:right-[100px] 2xl:top-16
            4xl:right-[160px] 4xl:top-10
            w-[80px] h-[80px] 
            lg:w-[112.746px] lg:h-[112.746px] 
            3xl:w-[140px] 3xl:h-[140px] 
            4xl:w-[160px] 4xl:h-[160px] 
            flex items-center justify-center transform rotate-[5deg]"
          >
            <img
              src={ShieldCheck}
              alt="Shield Check"
              className="w-[60px] h-[60px] lg:w-[84px] lg:h-[84px] 3xl:w-[105px] 3xl:h-[105px] 4xl:w-[120px] 4xl:h-[120px]"
            />
          </div>

          <p className="text-lg md:text-xl text-black max-w-2xl mx-auto font-normal">
            Turn content theft into recurring revenue. Protect your videos and
            automatically claim royalties when others use your content.
          </p>
        </div>

        {/* Community Section */}
        <div className="flex items-center justify-center gap-[10px]">
          <div className="grid-cols-[max-content] grid-rows-[max-content] inline-grid leading-[0] place-items-start relative">
            <img
              src={Avatar1}
              alt="Creator Avatar 1"
              className="w-10 h-10 rounded-full object-cover [grid-area:1_/_1] ml-0 mt-0"
            />
            <img
              src={Avatar2}
              alt="Creator Avatar 2"
              className="w-10 h-10 rounded-full object-cover [grid-area:1_/_1] ml-[26px] mt-0"
            />
            <img
              src={Avatar3}
              alt="Creator Avatar 3"
              className="w-10 h-10 rounded-full object-cover [grid-area:1_/_1] ml-[52px] mt-0"
            />
            <img
              src={Avatar4}
              alt="Creator Avatar 4"
              className="w-10 h-10 rounded-full object-cover [grid-area:1_/_1] ml-[78px] mt-0"
            />
          </div>
          <p className="text-[#FF6B35] text-lg font-normal">
            Join over 3,500+ creators
          </p>
        </div>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <CSTertiaryBtn
            name="Learn more about CS"
            className="w-fit"
            onClick={() => scrollTo("how-it-works")}
          />
          <Link to="/esign">
            <CSPrimaryBtn name="Start earning today" className="w-fit" />
          </Link>
        </div>

        {/* Decorative Floating Icons */}
        <div className="absolute left-[calc(50%+600.7px)] top-[458px] translate-x-[-50%] w-[79.391px] h-[79.391px] items-center justify-center transform rotate-[540deg] hidden lg:flex">
          <img
            src={FolderSeach}
            alt="Decorative Icon"
            className="w-[62px] h-[62px] slow-spin"
            style={{ animationDelay: '0s' }}
          />
        </div>
        <div className="absolute left-[calc(50%+460px)] -top-[30px] translate-x-[-50%] w-[73.485px] h-[73.485px] items-center justify-center transform rotate-[155deg] hidden lg:flex">
          <img
            src={Video}
            alt="Decorative Icon"
            className="w-[60px] h-[60px] slow-spin"
            style={{ animationDelay: '0s' }}
          />
        </div>
        <div className="absolute left-[calc(50%-530.16px)] top-[441px] translate-x-[-50%] w-[71.685px] h-[71.685px] items-center justify-center transform rotate-[9.842deg] hidden lg:flex">
          <img
            src={Fingerprint}
            alt="Decorative Icon"
            className="w-[62px] h-[62px] slow-spin"
            style={{ animationDelay: '0s' }}
          />
        </div>
        <div className="absolute left-[calc(50%-550px)] -top-[30px] translate-x-[-50%] w-[76.282px] h-[76.282px] items-center justify-center transform rotate-[340.974deg] hidden lg:flex">
          <img src={Coin} alt="Decorative Icon" className="w-[60px] h-[60px] slow-spin" style={{ animationDelay: '3s' }} />
        </div>
        <div className="absolute left-[calc(50%-645.37px)] top-[615px] translate-x-[-50%] w-[77.266px] h-[77.266px] items-center justify-center transform rotate-[343.211deg] hidden xl:flex">
          <img
            src={ShieldCheckOutline}
            alt="Decorative Icon"
            className="w-[62px] h-[62px] slow-spin"
            style={{ animationDelay: '0s' }}
          />
        </div>
        <div className="absolute left-[calc(50%-650px)] top-[160px] translate-x-[-50%] w-[57.33px] h-[57.33px] items-center justify-center transform rotate-[345.4deg] hidden xl:flex">
          <img
            src={FilePlay}
            alt="Decorative Icon"
            className="w-[47px] h-[47px] slow-spin"
            style={{ animationDelay: '0s' }}
          />
        </div>
        <div className="absolute left-[calc(50%+650px)] top-[185px] translate-x-[-50%] w-[58.731px] h-[58.731px] items-center justify-center transform rotate-[334.293deg] hidden xl:flex">
          <img
            src={DollarCoin}
            alt="Decorative Icon"
            className="w-[44px] h-[44px] slow-spin"
            style={{ animationDelay: '0s' }}
          />
        </div>
        <div className="absolute left-[calc(50%+599.41px)] top-[639.66px] translate-x-[-50%] w-[61.5px] h-[61.5px] items-center justify-center transform rotate-[8.641deg] hidden xl:flex">
          <img src={Film} alt="Decorative Icon" className="w-[54px] h-[54px] slow-spin" style={{ animationDelay: '0s' }} />
        </div>

        {/* Background Vector/Graphic Element */}
        <div className="absolute left-1/2 -translate-x-1/2 top-[-40px] lg:left-[-70px] xl:left-[80px] 1xl:left-[200px] 2xl:left-[210px] 4xl:left-[300px] lg:translate-x-0 xxs:left-[130px] xxs:top-[-10px] xs:left-[190px] xs:top-[-40px] md:left-[320px] md:top-[50px] lg:top-[-120px] xl:top-[-80px] 1xl:top-[-80px] 2xl:top-[-70px] 3xl:top-0 w-[400px] h-[400px] lg:w-[650px] lg:h-[650px] 4xl:top-[-100px] pointer-events-none z-[1]">
          <img
            src={BlurBg}
            alt="Background Vector"
            className="w-full h-full object-contain"
            style={{ opacity: 1.15 }}
          />
        </div>
      </div>
      <Statistics />
    </div>
  );
}
